import NewButton from "../NewButton";
import Icon from "../Icon";
import Text from "../Text";
import React from "react";
import styled from "styled-components";
import { themeProp } from "../../theme";
import { Space } from "antd";
import PropTypes from "prop-types";
import Highlighter from "../Highlighter";
import { useString as s } from "../StringProvider";
import Tooltip from "../Tooltip";

const KPILibraryItem = ({ kpi, onAdd, searchTerm }) => {
  const toolTipText = s(
    "discovery.kpiLibrary.tooltip.addKPI.text",
    "Add Outcome"
  );

  return (
    <Tooltip title={toolTipText} placement={"top"}>
      <KPILibraryItemContainer
        data-cy={"kpi-library-item"}
        id={`kpi-library-item-${kpi.code}`}
        onClick={onAdd}
      >
        <Space direction={"horizontal"} size={16}>
          <NewButton type={"iconPrimary"}>
            <Icon
              data-cy={`kpi-library-plus-icon-${kpi.code}`}
              name={"plusCircle"}
              size={"large"}
              colour={"primary"}
            />
          </NewButton>
          <Text variant={"h4"} color={"text"}>
            {searchTerm ? (
              <Highlighter
                textToHighlight={kpi.name}
                searchWords={[searchTerm]}
              />
            ) : (
              <b>{kpi.name}</b>
            )}
          </Text>
        </Space>
      </KPILibraryItemContainer>
    </Tooltip>
  );
};

const KPILibraryItemContainer = styled.div`
  padding: 16px 24px 16px 24px;
  margin-bottom: 8px;
  border-style: solid;
  border-color: ${themeProp("palette.gray1")};
  border-width: 1px;
  border-radius: 8px;

  &:hover {
    background-color: ${themeProp(`components.newButton.text.backgroundHover`)};
    cursor: pointer;
  }
`;

KPILibraryItem.propTypes = {
  kpi: PropTypes.object.isRequired,
  onAdd: PropTypes.func.isRequired
};

export default KPILibraryItem;
